module.exports = __webpack_public_path__ + "media/images/logos/wind-energy-hamburg-9da468983319011770fcbe4f57cbc9c9.svg";